module.exports = __webpack_public_path__ + "static/media/ic_returns.251ba039.svg";